import React, { useState, useEffect, useRef } from "react";
import { availableServices } from "./data";
import { loadOpinions } from "./../api";
import "./Comments.css";

const Comments = () => {
  const [opinions, setOpinions] = useState([]); // State for the list of opinions
  const [filter, setFilter] = useState(""); // State for the selected filter
  const [error, setError] = useState(null); // State for error messages
  const [currentPage, setCurrentPage] = useState(1); // State for the current page
  const [totalPages, setTotalPages] = useState(1); // State for the total number of pages
  const commentsRef = useRef(null); // Reference to the comments container

  useEffect(() => {
    const fetchOpinions = async () => {
      try {
        const data = await loadOpinions(currentPage, filter); // Pass filter as is
        setOpinions(data.opinions);
        setTotalPages(data.totalPages);
        setError(null);
      } catch (error) {
        console.error("Error fetching opinions:", error);
        setError("Error loading opinions. Please try again later.");
      }
    };
    fetchOpinions();
  }, [filter, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (commentsRef.current) {
      commentsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value; // Single value from the select
    setFilter(selectedFilter); // Set as a string ("" for "Filtros")
    setCurrentPage(1); // Reset to page 1 when filter changes
    if (commentsRef.current) {
      commentsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const renderPagination = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages < 2) {
      return null;
    }

    if (currentPage > 1) {
      pages.push(
        <button
          className="pag-arrows-btn"
          key="prev"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <img
            className="pag-arrows"
            src="paginacion derecha.png"
            alt="Previous"
          />
        </button>
      );
    }

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={i === currentPage}
          >
            {i}
          </button>
        );
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
      let startPage = Math.max(1, currentPage - halfMaxPagesToShow);
      let endPage = Math.min(totalPages, currentPage + halfMaxPagesToShow);

      if (currentPage <= halfMaxPagesToShow) {
        endPage = maxPagesToShow;
      } else if (currentPage >= totalPages - halfMaxPagesToShow) {
        startPage = totalPages - maxPagesToShow + 1;
      }

      if (startPage > 1) {
        pages.push(
          <button key={1} onClick={() => handlePageChange(1)}>
            {1}
          </button>
        );
        if (startPage > 2) {
          pages.push(
            <span className="ellipsis" key="ellipsis-start">
              ...
            </span>
          );
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={i === currentPage}
          >
            {i}
          </button>
        );
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pages.push(
            <span className="ellipsis" key="ellipsis-end">
              ...
            </span>
          );
        }
        pages.push(
          <button key={totalPages} onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </button>
        );
      }
    }

    if (currentPage < totalPages) {
      pages.push(
        <button
          className="pag-arrows-btn"
          key="next"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          <img className="pag-arrows" src="paginacion izq.png" alt="Next" />
        </button>
      );
    }

    return pages;
  };

  return (
    <>
      <div className="opinions-header">
        <p className="opinions-text">Opiniones de clientes</p>
      </div>

      {/* Filter opinions */}
      <div className="filter-btn-container">
        <select className="options-txt" value={filter} onChange={handleFilterChange}>
          <option  value="">Filtros</option>
          {availableServices.map((services) => (
            <option key={services} value={services}>
              {services}
            </option>
          ))}
        </select>
      </div>

      {error && <p className="error-message">{error}</p>}

      {/* Opinions container */}
      <div className="opinions-container" ref={commentsRef}>
        {opinions &&
          opinions.map((opinion) => (
            <div className="opinion" key={opinion._id}>
              <div className="opinion-header">
                <h4 className="name">{opinion.name}</h4>
                <p className="date">
                  {new Date(opinion.date).toLocaleDateString()}
                </p>
              </div>
              <p className="comment">{opinion.comment}</p>
              <p className="used-services">
                Services: {opinion.services.join(", ")}
              </p>
            </div>
          ))}
      </div>
      <div className="pagination">{renderPagination()}</div>
    </>
  );
};

export default Comments;
